import React, { useEffect, useState } from 'react';
import { digitalApi as api } from './api';
import { useAuth } from '../../context/AuthContext';
import { C } from '../../theme';
import CatalogueTable from './CatalogueTable';

export default function PlatformsPage() {
  const { canEditCatalogue, hasSites, isSuperAdmin } = useAuth();
  const [platforms, setPlatforms] = useState([]);
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);

  const load = (inactive = showInactive) => {
    Promise.all([api.getPlatforms(!inactive), api.getSites()])
      .then(([p, s]) => { setPlatforms(p); setSites(s); })
      .catch(()=>{})
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{ load(); },[]);  // eslint-disable-line react-hooks/exhaustive-deps

  function handleToggleShowInactive(v) {
    setShowInactive(v);
    load(v);
  }

  async function persist({ isNew, id, data }) {
    if (isNew) await api.createPlatform(data);
    else await api.updatePlatform(id, data);
  }

  async function handleDeactivate(platform, force) {
    await api.deletePlatform(platform.id, force);
  }

  async function handleReactivate(platform) {
    await api.updatePlatform(platform.id, { active: true });
    load();
  }

  return (
    <div style={C.page}>
      <div style={{ marginBottom:28 }}>
        <h1 style={C.title}>Platforms & Formats <span style={{ color:'#8aa0b8', fontWeight:400, fontSize:16 }}>({platforms.length})</span></h1>
        <div style={{ fontSize:12, color:'#8aa0b8', marginTop:4 }}>Global catalogue — available across all clients and plans</div>
      </div>
      {loading ? <div style={C.empty}>Loading…</div> : (
        <CatalogueTable scope="global" platforms={platforms} sites={sites} canEdit={canEditCatalogue} persist={persist} onReload={load} showPublisherCols={hasSites||isSuperAdmin}
          showInactive={showInactive} onToggleShowInactive={handleToggleShowInactive}
          onDeactivate={handleDeactivate} onReactivate={handleReactivate} isSuperAdmin={isSuperAdmin}/>
      )}
    </div>
  );
}
